module.exports = __webpack_public_path__ + "static/media/pin.b0dc5e67.svg";